export const LinkStyle = {
  // style object for base or default style
  baseStyle: {
    color: "primary",
    transition: "primary",
    _hover: {
      color: "white",
      textDecoration:"none"
    },
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {},
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: "",
    variant: "",
    colorScheme: "",
  },
};
